<template>
  <div class="form">
    <!-- <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <div class="container">
      <table class="table">
        <thead class="thead-dark">
          <tr>
            <th scope="col"># Solicitud</th>
            <th scope="col">Proyecto</th>
            <th scope="col">Fecha creación</th>
            <th scope="col">Tipo de conexión</th>
            <th scope="col">Tipo de solicitud</th>
            <th scope="col">Etapa</th>
            <th scope="col">Inicio de etapa actual</th>
            <th scope="col">Estado</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in requestList" :key="item.id">
            <th scope="row">{{item.id}}</th>
            <td>{{item.proyectName}}</td>
            <td>{{item.createdDate | formatDate}}</td>
            <td>{{item.conectionType}}</td>
            <td>{{item.serviceDetail.requestedService.description}}</td>
            <td>
              {{item.stage == 'solicitud-servicio' ? 'Solicitud de servicio':''}}
              {{item.stage == 'factibilidad-servicio' ? 'Factibilidad de servicio':''}}
              {{item.stage == 'aprobacion-disenos' ? 'Aprobación de diseños':''}}
              {{item.stage == 'pendiente-disenos' ? 'Pendiente de envío de diseños':''}}
              {{item.stage == 'pendiente-solicitud-supervision' ? 'Pendiente de solicitud de supervisión':''}}
              {{item.stage == 'pendiente-asignacion-supervision' ? 'Asignación de supervisión':''}}  
              {{item.stage == 'ejecucion-obras' ? 'Ejecución de obras':''}}
              {{item.stage == 'puesta-en-servicio' ? 'Puesta en servicio':''}}
              {{item.stage == 'anulado' ? 'Anulado':''}}
                {{item.stage == 'finalizado' ? 'Finalizado':''}}
            </td>
            <td>{{item.editedDate | formatDate}}</td>
            <td>
              <div :class="{
                'request-blue':item.status == 'en proceso',
                'request-red':item.status == 'rechazado' || item.status == 'anulado',
                'request-green':item.status == 'finalizado',
              }">
                {{item.status}}
              </div>
            </td>
            <td>
              <div class="app-icon" @click="requestDetail(item)">
                <v-icon name="eye" scale="1.5"/>
              </div>
            </td>
          </tr>
          <!-- <tr>
            <th scope="row">036</th>
            <td>10/12/2021</td>
            <td>Juan Perez</td>
            <td>Completado</td>
            <td>
              <div class="app-icon" @click="$router.push('requestDetail')">
                <v-icon name="eye" scale="1.5"/>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">003</th>
            <td>10/9/2021</td>
            <td>Juan Perez</td>
            <td>Completado</td>
            <td>
              <div class="app-icon" @click="$router.push('requestDetail')">
                <v-icon name="eye" scale="1.5"/>
              </div>
            </td>
          </tr> -->
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  data(){
    return {
      //requestList: {}
    }
  },
  computed:{
    ...mapState({
      requestList: 'requestList'
    }),
  },
  beforeMount(){
    if (!this.requestList) {
      this.$router.push('consults');
      return;
    }
  },
  mounted(){
    if (this.requestList == null) {
      this.$router.push('/');
    }else{
      this.requestList = this.requestList;
    }
  },
  methods: {
    requestDetail(item){
      this.setRequestDetail(item);
      this.$router.push('requestDetail')
    },
    ...mapMutations({
      setRequestDetail: 'setRequestDetail'
    }),
  }
}
</script>

<style lang="scss">
.icon {
  width: 16px;
  height: 16px;
}
.icon-account-login {
  fill: #f00;
}
.form {
  padding: 50px 0;
  .container {
    // background-color: #444444;
  }
}
</style>